import Repository from "@shared/services/api/abstracts/Repository";
import { UrlRouteMap } from "@shared/services/api/types";
import { BrandingConfigSerializer } from "../types";

/**
 * Public repository for fetching venue branding configuration.
 *
 * Used for public-facing pages where venue-based auth isn't available.
 * The `resolve` endpoint determines branding config from model type and instance ID.
 *
 * @example
 * const repo = new PublicBrandingConfigRepository();
 * const config = await repo.retrieve("resolve", {
 *   params: { model_type: "event", instance_id: 123 }
 * });
 */
export default class PublicBrandingConfigRepository extends Repository<BrandingConfigSerializer> {
  public readonly repositoryName = "PublicBrandingConfigRepository";

  public readonly endpoint = "api/public/venues/branding-configs/";

  public get urlMap(): UrlRouteMap {
    return {
      ...this.defaultUrlMap,
      resolve: "resolve",
    };
  }
}
